import { FOLDER_CONSTANTS } from '@_entities/content';

// 분리할 유틸리티 함수
export function sanitizeFolderName(input: string): string {
	let sanitizedInput = input;

	// 첫 글자가 공백인 경우 제거
	while (sanitizedInput[0] === ' ') {
		sanitizedInput = sanitizedInput.slice(1);
	}

	// 최대 길이 제한
	return sanitizedInput.length > FOLDER_CONSTANTS.FOLDER_NAME_MAX_LENGTH
		? sanitizedInput.slice(0, FOLDER_CONSTANTS.FOLDER_NAME_MAX_LENGTH)
		: sanitizedInput;
}
